// extracted by mini-css-extract-plugin
export default {"body":"BodyStyles_body__He0RM"};